var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"challenges-page"}},[_c('datatable',{ref:"dtComponent",attrs:{"modelData":_vm.dtData,"combineData":{value:['start_time', 'end_time'], dateFormat: true, join: ' - '}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }